import React from 'react'
import cx from 'classnames'

import META from '@/meta'
import ThemeProvider from '@/themeProvider.js'
import Footer from '@/footer.js'
import ComingSoon from '@/modules/comingSoon.js'
import ApplyFrom from '@/modules/applyForm.js'

const Apply = ({ transitionStatus, entry, exit }) => {
  const metaData = {
    title: 'apply to re:store',
    keywords: 're:store, ',
    description: 'apply to re:store',
    url: 'apply'
  }
  return (
    <div className={cx('animate__page', transitionStatus)}>
      <META metaData={metaData} />
      <ThemeProvider color={`two`} />
      <div className='nav--spacer' />
      <ApplyFrom />
      <ComingSoon />
      <Footer />
    </div>
  )
}

export default Apply